declare global {
  interface Window {
    APP_CONFIG?: any;
  }
}
let rawEnv;
if (window.Cypress) {
  const APP_CONFIG = {
    REACT_APP_PRODUCTION: false,
    REACT_APP_SERVICE_BASE_URL: 'http://staging.api.leagueside.com/v1',
    REACT_APP_GRAPHQL_URI: 'http://staging.api.leagueside.com/graphql',
    REACT_APP_HUBSPOT_PORTAL_ID: 6130589,
    REACT_APP_PLACES_API_KEY: 'keykey123123',
    REACT_APP_CARTO_BASEMAP_KEY: 'default_public',
    REACT_APP_VERIFICATIONS_REPORT_URL:
      'https://leagueside-bi.herokuapp.com/dashboard/14',
  };
  rawEnv = APP_CONFIG;
} else {
  rawEnv = window.APP_CONFIG || null;
}

export const env = rawEnv;

if (!env) {
  throw new Error('APP_CONFIG is not defined');
}

export const { REACT_APP_PRODUCTION } = env;
export const CLOUDINARY_CLOUD_NAME = 'hkbmuwkku';
